"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefreshModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Static = require("../Static/Static");
var RefreshModal = exports.RefreshModal = function RefreshModal(_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title,
    children = _ref.children,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Refresh Browser' : _ref$buttonText;
  return /*#__PURE__*/_react["default"].createElement(_Static.StaticModal, {
    isOpen: isOpen,
    title: title,
    buttonText: buttonText,
    onButtonClick: function onButtonClick() {
      return window.location.reload();
    }
  }, children);
};
RefreshModal.propTypes = {
  title: _propTypes.PropTypes.string.isRequired,
  isOpen: _propTypes.PropTypes.bool.isRequired
};